import { Helmet } from "react-helmet-async"
import { TripsList } from "../../../../Trips"
import { useParams } from "../../../../router-utils"

export default function TouristProfileTripsPage() {
	const { touristProfileId } = useParams(
		"/tourist-profiles/:touristProfileId/trips"
	)
	return (
		<>
			<Helmet>
				<title>Tourist Profile Trips</title>
			</Helmet>
			<TripsList
				disableAddition
				hideBulkActions
				hideTouristProfileFilter
				touristProfileIds={touristProfileId}
				showFilters={false}
				canDownloadTrips={false}
			/>
		</>
	)
}
